export enum FilterCampionarioProduzione {
    CampionarioEProduzione,
    SoloCampionario,
    SoloProduzione,
}
